import { RouteRecordRaw } from 'vue-router';
import LoginView from '~views/LoginView.vue';
import PageNotFound from '~views/PageNotFound.vue';
import AppListView from '~views/AppListView.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: PageNotFound,
  },
  {
    path: '/',
    redirect: '/login',
    name: 'home',
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/app-list',
    name: 'AppListView',
    component: AppListView,
    meta: { requiresAuth: true },
  },
];

export default routes;
